module.exports = __webpack_public_path__ + "static/media/map-pin.f6345f09.svg";